import { Component, ComponentRef, ElementRef, EventEmitter, Input, Output, Optional, ViewContainerRef, Host } from '@angular/core';
import { C4InputConfig, C4Option, C4Input, C4InputInterface, SENSIBLE_DEFAULT_CONFIG } from '../c4-input';
import { C4Form } from '../c4-form';
import { Subscription } from 'rxjs/Subscription';

import { C4InputCheckbox } from '../checkbox/c4-input-checkbox';
import { C4InputColor } from '../color/c4-input-color';
import { C4InputDate } from '../date/c4-input-date';
import { C4InputDatetime } from '../datetime/c4-input-datetime';
import { C4InputEmail } from '../email/c4-input-email';
import { C4InputFloat } from '../float/c4-input-float';
import { C4InputInteger } from '../integer/c4-input-integer';
import { C4InputList } from '../list/c4-input-list';
import { C4InputMonth } from '../month/c4-input-month';
import { C4InputPassword } from '../password/c4-input-password';
import { C4InputRadio } from '../radio/c4-input-radio';
import { C4InputSelect } from '../select/c4-input-select';
import { C4InputSliderFloat } from '../slider-float/c4-input-slider-float';
import { C4InputSliderInteger } from '../slider-integer/c4-input-slider-integer';
import { C4InputTel } from '../tel/c4-input-tel';
import { C4InputText } from '../text/c4-input-text';
import { C4InputTime } from '../time/c4-input-time';
import { C4InputUrl } from '../url/c4-input-url';
import { C4InputWeek } from '../week/c4-input-week';

@Component({
  selector: 'c4-input-factory',
  template: '<span #c4InputContainer></span>'
})
export class C4InputFactory {

  @Input() config;
  @Input() model;

  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  subscription: Subscription;

  inputComponents: any;

  private form: C4Form;

  constructor(
    private elementRef: ElementRef,
    private viewContainer: ViewContainerRef,
    @Optional() @Host() form: C4Form
  ) {
    this.form = form;
  }

  ngOnInit() {
    this.config = this.config || (this.form || { config: undefined }).config || SENSIBLE_DEFAULT_CONFIG;

    this.inputComponents = {
      'checkbox': C4InputCheckbox,
      'color': C4InputColor,
      'date': C4InputDate,
      'datetime': C4InputDatetime,
      'email': C4InputEmail,
      'float': C4InputFloat,
      'integer': C4InputInteger,
      'list': C4InputList,
      'month': C4InputMonth,
      'radio': C4InputRadio,
      'select': C4InputSelect,
      'slider-float': C4InputSliderFloat,
      'slider-integer': C4InputSliderInteger,
      'tel': C4InputTel,
      'text': C4InputText,
      'time': C4InputTime,
      'url': C4InputUrl,
    }

    // this.loader.loadNextToLocation(this.getComponent(this.model), this.viewContainer)
    //   .then((component: ComponentRef<C4InputInterface>) => {
    //     var input: C4InputInterface = component.instance;
    //     input.init(this.model, this.config);
    //     this.subscription = input.valueChange.subscribe((value) => this.valueChange.next(value));
    //   });
  }

  getComponent(model: C4Option): any {
    if (model.type == "RANGE" && model.valueType == "INT") return this.inputComponents['slider-integer'];
    if (model.type == "RANGE" && model.valueType == "FLOAT") return this.inputComponents['slider-float'];
    if (model.type == "INT") return this.inputComponents['integer'];
    if (model.type == "FLOAT") return this.inputComponents['float'];
    if (model.type == "HEXCOLOR") return this.inputComponents['color'];
    if (model.type == "LIST") return this.inputComponents['select'];
    if (model.type == "BOOLEAN") return this.inputComponents['checkbox'];

    // TODO: Other input types

    console.warn('c4-input-factory.ts: Could not determine which input type to used based upon model provided.');
    console.warn('c4-input-factory.ts: model: %O', model);
    console.warn('c4-input-factory.ts: Defaulting to text input.');

    return this.inputComponents['text'];
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/factories/c4-input-factory.ts